'use client';
import InputLabel from '@mui/material/InputLabel';
import { useTheme } from '@mui/material/styles';
import TextField from '@mui/material/TextField';

type Props = {
  keyword: string;
  setKeyword: (keyword: string) => void;
};

export const KeywordInput: React.FC<Props> = ({ keyword, setKeyword }) => {
  const theme = useTheme();
  return (
    <>
      <InputLabel htmlFor="searchbox-keyword" sx={theme.typography.body2}>
        キーワードで絞り込む
      </InputLabel>
      <TextField
        id="searchbox-keyword"
        fullWidth
        size="small"
        placeholder="キーワードを入力"
        value={keyword}
        onChange={(e) => setKeyword(e.target.value)}
      />
    </>
  );
};
